module.exports = __webpack_public_path__ + "static/img/Main beam 3.0m (hollow 50x50 x3.0m).5d929f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Main beam 3.0m (hollow 50x50 x3.0m).jpg
// module id = 87
// module chunks = 1